import { render } from "./PartSerialForm.vue?vue&type=template&id=1ed49628"
import script from "./PartSerialForm.vue?vue&type=script&lang=js"
export * from "./PartSerialForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__